// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ==================== RENDER ADDITIONAL DOCS STYLES ==================== */
.additional-docs-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* Header Section */
  /* No Data State */
  /* ==================== TABLE VIEW ==================== */
  /* ==================== GRID VIEW ==================== */
}
.additional-docs-container .docs-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.additional-docs-container .docs-header .docs-summary {
  display: flex;
  align-items: center;
  gap: 10px;
}
.additional-docs-container .docs-header .docs-summary p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}
.additional-docs-container .docs-header .docs-actions-right {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}
.additional-docs-container .docs-header .docs-actions-right .view-toggles {
  display: flex;
  gap: 4px;
}
.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.3rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 500;
  background-color: transparent;
  color: #444;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn svg {
  font-size: 1rem;
  color: inherit;
}
.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn:hover {
  background-color: #f3f4f6;
}
.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn.active {
  background-color: #e5e7eb;
  color: #222;
  border-color: #cbd5e1;
}
.additional-docs-container .docs-header .docs-actions-right .add-doc-btn button {
  background: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 18px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}
.additional-docs-container .docs-header .docs-actions-right .add-doc-btn button:hover {
  background: #0052a3;
}
.additional-docs-container .no-data-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  text-align: center;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  border: 2px dashed #cbd5e1;
  min-height: 200px;
}
.additional-docs-container .no-data-container .no-data-title {
  font-weight: 600;
  color: #374151;
  margin-bottom: 0.5rem;
}
.additional-docs-container .no-data-container .no-data-message {
  font-size: 1rem;
  color: #6b7280;
  max-width: 400px;
  line-height: 1.5;
}
.additional-docs-container .table-responsive {
  width: 100%;
  overflow-x: auto;
  padding-bottom: 10px;
}
.additional-docs-container .table-responsive::-webkit-scrollbar {
  height: 6px;
}
.additional-docs-container .table-responsive::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}
.additional-docs-container .documents-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}
.additional-docs-container .documents-table thead {
  background-color: #f1f5f9;
}
.additional-docs-container .documents-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
  font-weight: 600;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
  font-size: 14px;
}
.additional-docs-container .documents-table tbody tr {
  transition: background-color 0.2s ease;
  cursor: pointer;
  position: relative;
}
.additional-docs-container .documents-table tbody tr:hover {
  background-color: #f9fafb;
}
.additional-docs-container .documents-table tbody tr:not(:last-child) td {
  border-bottom: 1px solid #f1f5f9;
}
.additional-docs-container .documents-table tbody tr td {
  padding: 0.9rem 1rem;
  color: #374151;
  vertical-align: middle;
}
.additional-docs-container .documents-table tbody tr td.actions-cell {
  position: relative;
  min-width: 150px;
}
.additional-docs-container .documents-table tbody tr td .status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}
.additional-docs-container .documents-table tbody tr td .status-badge.pending {
  background-color: #fef3c7;
  color: #92400e;
}
.additional-docs-container .documents-table tbody tr td .status-badge.uploaded {
  background-color: #d1fae5;
  color: #065f46;
}
.additional-docs-container .documents-table tbody tr td .status-badge.requested {
  background-color: #dbeafe;
  color: #1e40af;
}
.additional-docs-container .documents-table tbody tr td .doc-status-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.additional-docs-container .documents-table tbody tr td .doc-status-badge.uploaded {
  background-color: #059669;
}
.additional-docs-container .documents-table tbody tr td .doc-status-badge.requested {
  background-color: #0284c7;
}
.additional-docs-container .documents-table tbody tr td .doc-status-badge.pending {
  background-color: #d97706;
}
.additional-docs-container .documents-table tbody tr td .doc-status-badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.additional-docs-container .documents-table tbody tr td .description-cell {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.additional-docs-container .documents-table .table-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.additional-docs-container .documents-table .table-actions button {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background-color: white;
  color: #374151;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.additional-docs-container .documents-table .table-actions button.upload-btn {
  color: var(--primary-color);
  border-color: var(--primary-color);
}
.additional-docs-container .documents-table .table-actions button.upload-btn:hover {
  background-color: var(--primary-color);
  color: white;
}
.additional-docs-container .documents-table .table-actions button.view-btn {
  color: #059669;
  border-color: #059669;
}
.additional-docs-container .documents-table .table-actions button.view-btn:hover {
  background-color: #059669;
  color: white;
}
.additional-docs-container .documents-grid-layout {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  padding: 10px 2px;
}
.additional-docs-container .documents-grid-layout .modern-document-card {
  background-color: #fff;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  height: 100%;
  cursor: pointer;
  position: relative;
  /* Status Badge (Top-Right Corner) */
  /* Header Strip */
  /* Content Body */
  /* Card Footer Actions */
}
.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 10px 4px 16px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  border-bottom-left-radius: 12px;
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);
  animation: fadeInScale 0.4s ease-in-out;
  z-index: 2;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge.uploaded {
  background-color: #059669;
}
.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge.requested {
  background-color: #0284c7;
}
.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge.pending {
  background-color: #d97706;
}
.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge::before {
  content: "✨";
  position: absolute;
  top: -8px;
  right: -10px;
  font-size: 14px;
  animation: sparkle 1.5s infinite ease-in-out;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip {
  background-color: #f8fafb;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #e2e8f0;
  transition: background 0.3s ease;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip .doc-name-badge {
  font-weight: 700;
  font-size: 0.95rem;
  color: var(--primary-color);
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1 1;
  min-width: 0;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip .doc-name-badge .type-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip .doc-name-badge .name-text {
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1;
  /* Horizontal Row for Two Items Side by Side */
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row-horizontal {
  display: flex;
  gap: 12px;
  width: 100%;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row-horizontal .detail-row-half {
  flex: 1 1;
  min-width: 0;
}
@media (max-width: 480px) {
  .additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row-horizontal {
    flex-direction: column;
    gap: 8px;
  }
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6b7280;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label .row-icon {
  font-size: 0.9rem;
  color: #9ca3af;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value {
  font-size: 0.9rem;
  color: #1f2937;
  font-weight: 500;
  padding-left: 2px;
  line-height: 1.5;
  word-break: break-word;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text {
  color: #4b5563;
  max-height: 100px;
  overflow-y: auto;
  padding-right: 4px;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {
  width: 3px;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {
  background: none;
  border: none;
  color: var(--primary-color);
  font-weight: 600;
  cursor: pointer;
  font-size: 0.8rem;
  margin-left: 5px;
  padding: 0;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {
  text-decoration: underline;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill.pending {
  background-color: #fef3c7;
  color: #92400e;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill.uploaded {
  background-color: #d1fae5;
  color: #065f46;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill.requested {
  background-color: #dbeafe;
  color: #1e40af;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions {
  padding: 12px 16px;
  border-top: 1px solid #f0f0f0;
  background-color: #fafbfc;
  display: flex;
  gap: 8px;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid;
  font-weight: 600;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.upload-btn {
  background-color: rgba(0, 123, 255, 0.05);
  color: var(--primary-color);
  border-color: var(--primary-color);
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.upload-btn:hover {
  background-color: var(--primary-color);
  color: white;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.view-btn {
  background-color: rgba(5, 150, 105, 0.05);
  color: #059669;
  border-color: #059669;
}
.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.view-btn:hover {
  background-color: #059669;
  color: white;
}

/* ==================== ANIMATIONS ==================== */
@keyframes fadeInScale {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes sparkle {
  0%, 100% {
    opacity: 0.5;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}
/* ==================== RESPONSIVE STYLES ==================== */
@media (max-width: 768px) {
  .additional-docs-container .docs-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .additional-docs-container .docs-header .docs-actions-right {
    margin-left: 0;
    width: 100%;
    justify-content: space-between;
  }
  .additional-docs-container .documents-grid-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  .additional-docs-container .documents-table {
    font-size: 0.85rem;
  }
  .additional-docs-container .documents-table thead th,
  .additional-docs-container .documents-table tbody td {
    padding: 0.75rem 0.5rem;
  }
}
@media (max-width: 480px) {
  .additional-docs-container .docs-header .docs-summary {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .additional-docs-container .docs-header .docs-actions-right {
    flex-direction: column;
    width: 100%;
  }
  .additional-docs-container .docs-header .docs-actions-right .view-toggles {
    width: 100%;
    justify-content: stretch;
  }
  .additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn {
    flex: 1 1;
  }
  .additional-docs-container .docs-header .docs-actions-right .add-doc-btn {
    width: 100%;
  }
  .additional-docs-container .docs-header .docs-actions-right .add-doc-btn button {
    width: 100%;
  }
  .additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions {
    flex-direction: column;
  }
  .additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/style/RenderAdditionalDocs.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,4EAAA;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EAGA,mBAAA;EA6FA,kBAAA;EA8BA,yDAAA;EAuMA,wDAAA;AAjUF;AAAE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AAEJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACN;AAEM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAKI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;AAHN;AAMM;EACE,aAAA;EACA,QAAA;AAJR;AAOQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AALV;AAQU;EACE,eAAA;EACA,cAAA;AANZ;AAUU;EACE,yBAAA;AARZ;AAYU;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAVZ;AAiBQ;EACE,gCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAfV;AAkBU;EACE,mBAAA;AAhBZ;AAyBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,0BAAA;EACA,iBAAA;AAvBJ;AA0BI;EACE,gBAAA;EACA,cAAA;EACA,qBAAA;AAxBN;AA4BI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AA1BN;AAgCE;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;AA9BJ;AAiCI;EACE,WAAA;AA/BN;AAiCI;EACE,yBAAA;EACA,kBAAA;AA/BN;AAoCE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AAlCJ;AAqCI;EACE,yBAAA;AAnCN;AAsCM;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,eAAA;AApCR;AA0CM;EACE,sCAAA;EACA,eAAA;EACA,kBAAA;AAxCR;AA2CQ;EACE,yBAAA;AAzCV;AA6CQ;EACE,gCAAA;AA3CV;AA+CQ;EACE,oBAAA;EACA,cAAA;EACA,sBAAA;AA7CV;AAgDU;EACE,kBAAA;EACA,gBAAA;AA9CZ;AAkDU;EACE,qBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAhDZ;AAmDY;EACE,yBAAA;EACA,cAAA;AAjDd;AAqDY;EACE,yBAAA;EACA,cAAA;AAnDd;AAuDY;EACE,yBAAA;EACA,cAAA;AArDd;AA0DU;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AAxDZ;AA2DY;EACE,yBAAA;AAzDd;AA6DY;EACE,yBAAA;AA3Dd;AA+DY;EACE,yBAAA;AA7Dd;AAiEY;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AA/Dd;AAoEU;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAlEZ;AAyEI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAvEN;AA0EM;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAxER;AA2EQ;EACE,2BAAA;EACA,kCAAA;AAzEV;AA4EU;EACE,sCAAA;EACA,YAAA;AA1EZ;AA+EQ;EACE,cAAA;EACA,qBAAA;AA7EV;AAgFU;EACE,yBAAA;EACA,YAAA;AA9EZ;AAuFE;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,iBAAA;AArFJ;AAwFI;EACE,sBAAA;EACA,mBAAA;EACA,yBAAA;EAEA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EAGA,oCAAA;EA0CA,iBAAA;EAwCA,iBAAA;EAgIA,wBAAA;AAxSN;AAuFM;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,8DAAA;EACA,uCAAA;EACA,UAAA;EACA,yCAAA;AArFR;AAwFQ;EACE,yBAAA;AAtFV;AA0FQ;EACE,yBAAA;AAxFV;AA4FQ;EACE,yBAAA;AA1FV;AA8FQ;EACE,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,4CAAA;AA5FV;AAkGM;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,gCAAA;AAhGR;AAmGQ;EACE,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAjGV;AAoGU;EACE,iBAAA;EACA,cAAA;AAlGZ;AAsGU;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AApGZ;AA2GM;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EAGA,8CAAA;AA3GR;AA4GQ;EACE,aAAA;EACA,SAAA;EACA,WAAA;AA1GV;AA6GU;EACE,SAAA;EACA,YAAA;AA3GZ;AA+GU;EAZF;IAaI,sBAAA;IACA,QAAA;EA5GV;AACF;AAgHQ;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA9GV;AAiHU;EACE,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA/GZ;AAkHY;EACE,iBAAA;EACA,cAAA;AAhHd;AAqHU;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAnHZ;AAsHY;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AApHd;AAuHc;EACE,UAAA;AArHhB;AAuHc;EACE,yBAAA;EACA,kBAAA;AArHhB;AAyHc;EACE,gBAAA;EACA,YAAA;EACA,2BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AAvHhB;AA0HgB;EACE,0BAAA;AAxHlB;AA8HY;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AA5Hd;AA+Hc;EACE,yBAAA;EACA,cAAA;AA7HhB;AAiIc;EACE,yBAAA;EACA,cAAA;AA/HhB;AAmIc;EACE,yBAAA;EACA,cAAA;AAjIhB;AA0IM;EACE,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,QAAA;AAxIR;AA2IQ;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAzIV;AA4IU;EACE,yCAAA;EACA,2BAAA;EACA,kCAAA;AA1IZ;AA6IY;EACE,sCAAA;EACA,YAAA;AA3Id;AAgJU;EACE,yCAAA;EACA,cAAA;EACA,qBAAA;AA9IZ;AAiJY;EACE,yBAAA;EACA,YAAA;AA/Id;;AAyJA,yDAAA;AACA;EACE;IACE,UAAA;IACA,qBAAA;EAtJF;EAwJA;IACE,UAAA;IACA,mBAAA;EAtJF;AACF;AA0JA;EACE;IACE,YAAA;IACA,qBAAA;EAxJF;EA0JA;IACE,UAAA;IACA,qBAAA;EAxJF;AACF;AA4JA,gEAAA;AACA;EAEI;IACE,sBAAA;IACA,uBAAA;EA3JJ;EA8JI;IACE,cAAA;IACA,WAAA;IACA,8BAAA;EA5JN;EAiKE;IACE,0BAAA;IACA,SAAA;EA/JJ;EAmKE;IACE,kBAAA;EAjKJ;EAoKI;;IAEE,uBAAA;EAlKN;AACF;AAwKA;EAGM;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAxKN;EA4KI;IACE,sBAAA;IACA,WAAA;EA1KN;EA6KM;IACE,WAAA;IACA,wBAAA;EA3KR;EA8KQ;IACE,SAAA;EA5KV;EAiLM;IACE,WAAA;EA/KR;EAkLQ;IACE,WAAA;EAhLV;EAyLM;IACE,sBAAA;EAvLR;EA0LQ;IACE,WAAA;EAxLV;AACF","sourcesContent":["@charset \"UTF-8\";\n/* ==================== RENDER ADDITIONAL DOCS STYLES ==================== */\n.additional-docs-container {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  /* Header Section */\n  /* No Data State */\n  /* ==================== TABLE VIEW ==================== */\n  /* ==================== GRID VIEW ==================== */\n}\n.additional-docs-container .docs-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n.additional-docs-container .docs-header .docs-summary {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.additional-docs-container .docs-header .docs-summary p {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n}\n.additional-docs-container .docs-header .docs-actions-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: auto;\n}\n.additional-docs-container .docs-header .docs-actions-right .view-toggles {\n  display: flex;\n  gap: 4px;\n}\n.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.3rem;\n  padding: 0.3rem 0.6rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  background-color: transparent;\n  color: #444;\n  border: 1px solid var(--border-color);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn svg {\n  font-size: 1rem;\n  color: inherit;\n}\n.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn:hover {\n  background-color: #f3f4f6;\n}\n.additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn.active {\n  background-color: #e5e7eb;\n  color: #222;\n  border-color: #cbd5e1;\n}\n.additional-docs-container .docs-header .docs-actions-right .add-doc-btn button {\n  background: var(--primary-color);\n  color: white;\n  border: none;\n  padding: 8px 18px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: background-color 0.2s;\n}\n.additional-docs-container .docs-header .docs-actions-right .add-doc-btn button:hover {\n  background: #0052a3;\n}\n.additional-docs-container .no-data-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 1.5rem;\n  text-align: center;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n  border-radius: 16px;\n  border: 2px dashed #cbd5e1;\n  min-height: 200px;\n}\n.additional-docs-container .no-data-container .no-data-title {\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 0.5rem;\n}\n.additional-docs-container .no-data-container .no-data-message {\n  font-size: 1rem;\n  color: #6b7280;\n  max-width: 400px;\n  line-height: 1.5;\n}\n.additional-docs-container .table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  padding-bottom: 10px;\n}\n.additional-docs-container .table-responsive::-webkit-scrollbar {\n  height: 6px;\n}\n.additional-docs-container .table-responsive::-webkit-scrollbar-thumb {\n  background-color: #cbd5e1;\n  border-radius: 4px;\n}\n.additional-docs-container .documents-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 0.5rem;\n  overflow: hidden;\n  font-size: 0.95rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n.additional-docs-container .documents-table thead {\n  background-color: #f1f5f9;\n}\n.additional-docs-container .documents-table thead th {\n  text-align: left;\n  padding: 1rem;\n  color: #111827;\n  font-weight: 600;\n  border-bottom: 1px solid #e2e8f0;\n  white-space: nowrap;\n  font-size: 14px;\n}\n.additional-docs-container .documents-table tbody tr {\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n  position: relative;\n}\n.additional-docs-container .documents-table tbody tr:hover {\n  background-color: #f9fafb;\n}\n.additional-docs-container .documents-table tbody tr:not(:last-child) td {\n  border-bottom: 1px solid #f1f5f9;\n}\n.additional-docs-container .documents-table tbody tr td {\n  padding: 0.9rem 1rem;\n  color: #374151;\n  vertical-align: middle;\n}\n.additional-docs-container .documents-table tbody tr td.actions-cell {\n  position: relative;\n  min-width: 150px;\n}\n.additional-docs-container .documents-table tbody tr td .status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n.additional-docs-container .documents-table tbody tr td .status-badge.pending {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n.additional-docs-container .documents-table tbody tr td .status-badge.uploaded {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n.additional-docs-container .documents-table tbody tr td .status-badge.requested {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n.additional-docs-container .documents-table tbody tr td .doc-status-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.additional-docs-container .documents-table tbody tr td .doc-status-badge.uploaded {\n  background-color: #059669;\n}\n.additional-docs-container .documents-table tbody tr td .doc-status-badge.requested {\n  background-color: #0284c7;\n}\n.additional-docs-container .documents-table tbody tr td .doc-status-badge.pending {\n  background-color: #d97706;\n}\n.additional-docs-container .documents-table tbody tr td .doc-status-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.additional-docs-container .documents-table tbody tr td .description-cell {\n  max-width: 300px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.additional-docs-container .documents-table .table-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n}\n.additional-docs-container .documents-table .table-actions button {\n  padding: 6px 12px;\n  border-radius: 6px;\n  border: 1px solid #e5e7eb;\n  background-color: white;\n  color: #374151;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.additional-docs-container .documents-table .table-actions button.upload-btn {\n  color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n.additional-docs-container .documents-table .table-actions button.upload-btn:hover {\n  background-color: var(--primary-color);\n  color: white;\n}\n.additional-docs-container .documents-table .table-actions button.view-btn {\n  color: #059669;\n  border-color: #059669;\n}\n.additional-docs-container .documents-table .table-actions button.view-btn:hover {\n  background-color: #059669;\n  color: white;\n}\n.additional-docs-container .documents-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  padding: 10px 2px;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card {\n  background-color: #fff;\n  border-radius: 12px;\n  border: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  transition: all 0.3s ease;\n  height: 100%;\n  cursor: pointer;\n  position: relative;\n  /* Status Badge (Top-Right Corner) */\n  /* Header Strip */\n  /* Content Body */\n  /* Card Footer Actions */\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 4px 10px 4px 16px;\n  font-size: 12px;\n  font-weight: 600;\n  color: white;\n  border-bottom-left-radius: 12px;\n  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%);\n  animation: fadeInScale 0.4s ease-in-out;\n  z-index: 2;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge.uploaded {\n  background-color: #059669;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge.requested {\n  background-color: #0284c7;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge.pending {\n  background-color: #d97706;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .doc-status-badge::before {\n  content: \"✨\";\n  position: absolute;\n  top: -8px;\n  right: -10px;\n  font-size: 14px;\n  animation: sparkle 1.5s infinite ease-in-out;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip {\n  background-color: #f8fafb;\n  padding: 12px 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #e2e8f0;\n  transition: background 0.3s ease;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip .doc-name-badge {\n  font-weight: 700;\n  font-size: 0.95rem;\n  color: var(--primary-color);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip .doc-name-badge .type-icon {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-header-strip .doc-name-badge .name-text {\n  word-break: break-word;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  flex: 1;\n  /* Horizontal Row for Two Items Side by Side */\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row-horizontal {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row-horizontal .detail-row-half {\n  flex: 1;\n  min-width: 0;\n}\n@media (max-width: 480px) {\n  .additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row-horizontal {\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #6b7280;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-label .row-icon {\n  font-size: 0.9rem;\n  color: #9ca3af;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value {\n  font-size: 0.9rem;\n  color: #1f2937;\n  font-weight: 500;\n  padding-left: 2px;\n  line-height: 1.5;\n  word-break: break-word;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text {\n  color: #4b5563;\n  max-height: 100px;\n  overflow-y: auto;\n  padding-right: 4px;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar {\n  width: 3px;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 4px;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text .read-more-btn {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 0.8rem;\n  margin-left: 5px;\n  padding: 0;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value.description-text .read-more-btn:hover {\n  text-decoration: underline;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill.pending {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill.uploaded {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-content-body .detail-row .detail-value .status-pill.requested {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions {\n  padding: 12px 16px;\n  border-top: 1px solid #f0f0f0;\n  background-color: #fafbfc;\n  display: flex;\n  gap: 8px;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 8px 12px;\n  border-radius: 6px;\n  border: 1px solid;\n  font-weight: 600;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.upload-btn {\n  background-color: rgba(0, 123, 255, 0.05);\n  color: var(--primary-color);\n  border-color: var(--primary-color);\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.upload-btn:hover {\n  background-color: var(--primary-color);\n  color: white;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.view-btn {\n  background-color: rgba(5, 150, 105, 0.05);\n  color: #059669;\n  border-color: #059669;\n}\n.additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button.view-btn:hover {\n  background-color: #059669;\n  color: white;\n}\n\n/* ==================== ANIMATIONS ==================== */\n@keyframes fadeInScale {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes sparkle {\n  0%, 100% {\n    opacity: 0.5;\n    transform: scale(0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n}\n/* ==================== RESPONSIVE STYLES ==================== */\n@media (max-width: 768px) {\n  .additional-docs-container .docs-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .additional-docs-container .docs-header .docs-actions-right {\n    margin-left: 0;\n    width: 100%;\n    justify-content: space-between;\n  }\n  .additional-docs-container .documents-grid-layout {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  .additional-docs-container .documents-table {\n    font-size: 0.85rem;\n  }\n  .additional-docs-container .documents-table thead th,\n  .additional-docs-container .documents-table tbody td {\n    padding: 0.75rem 0.5rem;\n  }\n}\n@media (max-width: 480px) {\n  .additional-docs-container .docs-header .docs-summary {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n  }\n  .additional-docs-container .docs-header .docs-actions-right {\n    flex-direction: column;\n    width: 100%;\n  }\n  .additional-docs-container .docs-header .docs-actions-right .view-toggles {\n    width: 100%;\n    justify-content: stretch;\n  }\n  .additional-docs-container .docs-header .docs-actions-right .view-toggles .toggle-btn {\n    flex: 1;\n  }\n  .additional-docs-container .docs-header .docs-actions-right .add-doc-btn {\n    width: 100%;\n  }\n  .additional-docs-container .docs-header .docs-actions-right .add-doc-btn button {\n    width: 100%;\n  }\n  .additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions {\n    flex-direction: column;\n  }\n  .additional-docs-container .documents-grid-layout .modern-document-card .card-footer-actions button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
